import {
  type ApiScopeRequirement,
  type OasWebPage,
  type OasWebTabsPage,
  isNonNullable,
  isOasWebPageApiTable,
  isOasWebPageCustom,
  isOasWebTabsPage,
  safeAbsurd,
} from '@ipfabric/utils';
import { createTableApiScopeRequirement } from 'utils/rbac/helpers/createTableApiScopeRequirement';

export const getPageTreeNodeRequiredPermissions = (
  node: OasWebTabsPage | OasWebPage,
): ApiScopeRequirement | undefined => {
  if (isOasWebPageApiTable(node)) {
    return createTableApiScopeRequirement(node.apiTable);
  }
  if (isOasWebPageCustom(node)) {
    return node.apiScopeRequirement;
  }
  if (isOasWebTabsPage(node)) {
    const requirements = node.tabs.map(getPageTreeNodeRequiredPermissions);
    return requirements.length > 0 && requirements.every(isNonNullable)
      ? { or: requirements }
      : undefined;
  }

  safeAbsurd(node, 'cannot determine menu url list for unknown node');
  return undefined;
};
